export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-09-16 at 3.19.11 PM (1).b4d9199a.png";